import { Component } from '@angular/core';
import {
    ApplicationInfoService,
    FoehnRemainingAlertsSummaryComponent,
    FormError,
    GesdemHandlerService,
    SdkDictionaryService
} from '@dsivd/prestations-ng';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-remaining-alerts-summary',
    template: `
        <div
            class="alert alert-danger"
            *ngIf="hasRemainingErrors | async"
            [innerHTML]="remainingErrorsLabel"
        ></div>
    `
})
export class RemainingAlertsSummaryComponent extends FoehnRemainingAlertsSummaryComponent {

    constructor(gesdemService: GesdemHandlerService, applicationInfoService: ApplicationInfoService, dictionaryService: SdkDictionaryService) {
        super(gesdemService, applicationInfoService, dictionaryService);
        this.hasRemainingErrors = gesdemService.updateFormDataSubject.pipe(
            map(() => {
                const errors = RemainingAlertsSummaryComponent.ignoreRequestSummaryErrors(gesdemService.lastResponse.errors);
                return !!errors.length;
            })
        );
    }

    private static ignoreRequestSummaryErrors(errors: FormError[]): FormError[] {
        return errors.filter(e => !e.name.startsWith('requestSummary.'));
    }
}
